import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-item', 'REMOVE_SHORTCUT', 'Pašalinti');
